module.exports = __webpack_public_path__ + "img/help4_dashboard_actions.1ca5aa75.png";